import { Icon } from '@iconify/react';
import Body from '@iconify/icons-clarity/accessibility-2-solid';
// https://icon-sets.iconify.design/clarity/accessibility-2-solid/

// material
import { alpha, styled } from '@mui/material/styles';
import { Card, Typography } from '@mui/material';
// utils
//import { fShortenNumber } from '../../../utils/formatNumber';

// ----------------------------------------------------------------------

const RootStyle = styled(Card)(({ theme }) => ({
  boxShadow: 'none',
  textAlign: 'center',
  //width: '100%',
  //height: '80%',
  //padding: theme.spacing(2, 2),
  padding: theme.spacing(5, 0),
  color: theme.palette.error.darker,
  backgroundColor: theme.palette.error.lighter
}));

const IconWrapperStyle = styled('div')(({ theme }) => ({
  margin: 'auto',
  display: 'flex',
  borderRadius: '50%',
  alignItems: 'center',
  width: theme.spacing(8),
  height: theme.spacing(8),
  justifyContent: 'center',
  marginBottom: theme.spacing(3),
  color: theme.palette.error.dark,
  backgroundImage: `linear-gradient(135deg, ${alpha(theme.palette.error.dark, 0)} 0%, ${alpha(
    theme.palette.error.dark,
    0.24
  )} 100%)`
}));

// ----------------------------------------------------------------------

/* data card */
const AVERAGE = '27.5 Kg/m²';

export default function IMCCard() {
  return (
    <RootStyle>
      <IconWrapperStyle>
        <Icon icon={Body} width={24} height={24} />
      </IconWrapperStyle>
      <Typography variant="h3">{AVERAGE}</Typography>
      <Typography variant="subtitle2" sx={{ opacity: 0.72 }}>
        Média IMC 
      </Typography>
    </RootStyle>
  );
}
